<div class="nodesContainer">
    <div class="particles" id="{{particleName}}"></div>
</div>